import type { CSSProperties } from 'react';

interface KaraokeTextFillStyleParams {
  fillRatio: number;
  fontColor: string;
  highlightColor?: string | null;
}

export const getKaraokeTextFillStyle = ({
  fillRatio,
  fontColor,
  highlightColor,
}: KaraokeTextFillStyleParams): CSSProperties => {
  const fillPercent = Math.round(Math.min(Math.max(fillRatio, 0), 1) * 100);
  const resolvedHighlightColor = highlightColor ?? fontColor;

  return {
    color: 'transparent',
    WebkitTextFillColor: 'transparent',
    WebkitTextStroke: '0',
    WebkitBackgroundClip: 'text',
    backgroundClip: 'text',
    backgroundImage: `linear-gradient(90deg, ${resolvedHighlightColor} 0%, ${resolvedHighlightColor} ${fillPercent}%, ${fontColor} ${fillPercent}%, ${fontColor} 100%)`,
    backgroundRepeat: 'no-repeat',
  };
};
